import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["children", "className", "color", "kind", "size", "width", "isDisabled", "isStretched"];
import React from 'react';
import pt from 'prop-types';
import { Flex, FlexItem, BreakpointContext, breakpointPropSwitch, Element } from '../';
import { appendHtmlClass, extendProps, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var BUTTON_KIND = getConfig('BUTTON_KIND');
var BUTTON_KIND_PREFIX = getConfig('BUTTON_KIND_PREFIX');
var BUTTON_KIND_DEFAULT = getConfig('BUTTON_KIND_DEFAULT');
var BUTTON_COLOR = getConfig('BUTTON_COLOR');
var BUTTON_COLOR_PREFIX = getConfig('BUTTON_COLOR_PREFIX');
var BUTTON_COLOR_DEFAULT = getConfig('BUTTON_COLOR_DEFAULT');
var BUTTON_SIZE = getConfig('BUTTON_SIZE');
var BUTTON_WIDTH = getConfig('BUTTON_WIDTH');
var ButtonBar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ButtonBar, _React$Component);
  function ButtonBar() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'button-bar';
    return _this;
  }
  var _proto = ButtonBar.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getColorClass = function getColorClass(color) {
    return color && color !== BUTTON_COLOR_DEFAULT ? "" + BUTTON_COLOR_PREFIX + color : null;
  };
  _proto.getKindClass = function getKindClass(kind) {
    return kind && kind !== BUTTON_KIND_DEFAULT ? "" + BUTTON_KIND_PREFIX + kind : null;
  };
  _proto.getClass = function getClass(className, color, kind, isDisabled, isStretched) {
    var classes = [this.DEFAULT_CLASS, this.getColorClass(color), this.getKindClass(kind)];
    if (isDisabled) classes.push('disabled');
    if (isStretched) classes.push('stretched');
    classes.forEach(function (i) {
      className = appendHtmlClass(className, i);
    });
    return className;
  };
  _proto.getChildren = function getChildren(children, color, kind, size, width, isDisabled, isStretched) {
    var key = 0;
    return React.Children.map(children, function (child) {
      if (isStretched) width = 'stretch';
      var flex = isStretched ? '1' : '0 1 auto';
      var props = {};
      if (kind) props.kind = kind;
      if (size) props.size = size;
      if (width) props.width = width;
      if (isDisabled === true || isDisabled === false) props.isDisabled = isDisabled;
      var className = '',
        isSelected = false;
      if (child.hasOwnProperty('props')) {
        if (color && !child.props.hasOwnProperty('color')) props.color = color;
        if (child.props.hasOwnProperty('className')) className = child.props.className;
        isSelected = child.props.hasOwnProperty('isSelected') && child.props.isSelected;
      }
      className = appendHtmlClass(className, 'button-bar-item');
      if (!isSelected) className = appendHtmlClass(className, 'unselected');
      props.className = className;
      var button = /*#__PURE__*/React.cloneElement(child, props);
      return /*#__PURE__*/React.createElement(FlexItem, {
        as: "li",
        key: key++,
        flex: flex
      }, button);
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      color = _this$props.color,
      kind = _this$props.kind,
      size = _this$props.size,
      width = _this$props.width,
      isDisabled = _this$props.isDisabled,
      isStretched = _this$props.isStretched,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    className = this.getClass(className, color, kind, isDisabled, isStretched);
    var flexChildren = this.getChildren(children, color, kind, size, width, isDisabled, isStretched);
    return /*#__PURE__*/React.createElement(Flex, Object.assign({
      as: "ul",
      className: className
    }, rest), flexChildren);
  };
  return ButtonBar;
}(React.Component);
ButtonBar.contextType = BreakpointContext;
Object.assign(ButtonBar, extendProps(Element, ['className', 'id', 'children', 'style', 'isAnimated'], {
  color: pt.oneOf(Object.keys(BUTTON_COLOR)),
  /**
   * Visual style of button and bar
   */
  kind: pt.oneOf(Object.keys(BUTTON_KIND)),
  /**
   * Button size e.g. 's'. Can be responsive e.g. ```{ 's': 'm', 'l': 'l' }```
   */
  size: responsivePropType.bind(this, pt.oneOf(Object.keys(BUTTON_SIZE))),
  /**
   * Button width specified as: 'normal' (depending on content), 'square' (fixed width and height), 'stretch' (full width of container). Can be responsive e.g. ```{ s: 'normal', l: 'stretch' }```
   */
  width: responsivePropType.bind(this, pt.oneOf(Object.keys(BUTTON_WIDTH))),
  isDisabled: pt.bool,
  /**
   * Is button bar stretched to fill entire container and its buttons share the space equally?
   */
  isStretched: pt.bool
}, {
  kind: 'normal',
  size: 'm'
}));
export default ButtonBar;